module.exports = __webpack_public_path__ + "media/images/giftcards/img-gift-success-93e4c8e83b8c89003ef5d367a091fb88.svg";